import { render } from "./AszfPage.vue?vue&type=template&id=0f7fe5e0&scoped=true"
import script from "./AszfPage.vue?vue&type=script&lang=js"
export * from "./AszfPage.vue?vue&type=script&lang=js"

import "./AszfPage.vue?vue&type=style&index=0&id=0f7fe5e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7fe5e0"]])

export default __exports__